import axiosInstance from './axiosInstance';

export const GetLogByModuleAndRecordId = (module, recordId) =>
    axiosInstance.get(`/Log/GetLogByModuleAndRecordId?module=${module}&recordId=${recordId}`);

export const getLogsBySalesId = (salesId) =>
    axiosInstance.get(`/Log/GetLogsBySalesId?salesId=${salesId}`);

export const createLog = (logData) =>
    axiosInstance.post("/Log/CreateLog", logData);

export const getLogsByModules = (modules, page = 1, pageSize = 50) =>
    axiosInstance.get('/Log/GetLogsByModules', { params: { modules, page, pageSize } });

export const getMentionableUsers = (module, recordId) =>
    axiosInstance.get('/Log/GetMentionableUsers', { params: { module, recordId } });

// Upload a remark attachment (image only, ≤5 MB). Returns { url, fileName }.
// The frontend embeds ![photo](url) markdown into the remark text at the cursor.
export const uploadRemarkImage = (file) => {
    const fd = new FormData();
    fd.append('file', file);
    return axiosInstance.post('/Log/UploadRemarkImage', fd, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
};